import CONSTANT from "../../constants/constant";
import Icon from "../Icon/Icon";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
import {
  QueueCardContainer,
  QueueImageContainer,
  QueueImage,
  QueueIconContainer,
} from "./QueueCard.styled";

const QueueCard = ({ thumbnailUrl, title, isPlayingNow, onClick }) => {
  return (
    <QueueCardContainer onClick={onClick}>
      <Stack direction="row" gap="4" alignItems="center">
        <QueueIconContainer>
          {isPlayingNow && <Icon size="24px" type={CONSTANT.ICON.PLAY} />}
        </QueueIconContainer>
        <Stack direction="row" gap="16" alignItems="center">
          <QueueImageContainer>
            <QueueImage src={thumbnailUrl} />
          </QueueImageContainer>
          <Stack direction="column" gap="8">
            <Title size="14px">{title}</Title>
          </Stack>
        </Stack>
      </Stack>
    </QueueCardContainer>
  );
};

export default QueueCard;
